module.exports = __webpack_public_path__ + "static/media/dollar-icon.b2765b7c.svg";